var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
/** Uma aba de Configuracoes. Cada uma e um ESCOPO: voce, a empresa, o sistema. */
let MyDataTabScope = class MyDataTabScope extends Scope {
    constructor() {
        super(...arguments);
        this.key = 'conta';
        this.label = '';
        this.active = false;
        this.onSelect = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", String)
], MyDataTabScope.prototype, "key", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MyDataTabScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MyDataTabScope.prototype, "active", void 0);
MyDataTabScope = __decorate([
    Observable
], MyDataTabScope);
export { MyDataTabScope };
/**
 * Um campo do formulario de perfil.
 *
 * Carrega o `span` - as classes de coluna da grade - porque na referencia cada
 * campo ocupa uma largura propria, e a grade e de dez colunas em `2xl`. Sem isso o
 * formulario sai com todos os campos do mesmo tamanho, que e outro desenho.
 */
let ProfileFieldScope = class ProfileFieldScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.placeholder = '';
        this.value = '';
        /** As classes de coluna, como `col-span-2 2xl:col-span-3`. */
        this.span = 'col-span-2';
        /** `text` para os campos comuns; `uf` para o seletor de UF, que abre uma lista. */
        this.kind = 'text';
        this.readOnly = false;
        this.disabled = false;
        /**
         * O `other` da referencia.
         *
         * No `Input` copiado ele e o que deixa a moldura com `opacity-40` quando o
         * campo esta desabilitado. So o e-mail do profissional o recebe.
         */
        this.dimmed = false;
        this.onChanged = Scope.SYNC_ACTION_STRING;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], ProfileFieldScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ProfileFieldScope.prototype, "placeholder", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ProfileFieldScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ProfileFieldScope.prototype, "span", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], ProfileFieldScope.prototype, "kind", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ProfileFieldScope.prototype, "readOnly", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ProfileFieldScope.prototype, "disabled", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ProfileFieldScope.prototype, "dimmed", void 0);
__decorate([
    observe(),
    __metadata("design:type", Number)
], ProfileFieldScope.prototype, "maxLength", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], ProfileFieldScope.prototype, "error", void 0);
ProfileFieldScope = __decorate([
    Observable
], ProfileFieldScope);
export { ProfileFieldScope };
/**
 * Configuracoes, organizada por ESCOPO.
 *
 * As abas nao sao assuntos, sao alcances - cada uma responde "isto vale para quem".
 * A tela anterior empilhava as tres secoes sem dizer isso, e o resultado previsivel
 * era concluir que os limites de status valiam para a empresa quando valem para o
 * usuario logado.
 *
 * Quais abas existem depende do papel, e so disso: quem administra uma empresa tem
 * "Minha empresa"; o administrador geral tem "Sistema"; quem nao e nem um nem outro
 * fica so com "Minha conta", e ai a barra de abas nem aparece.
 */
let MyDataScope = class MyDataScope extends Scope {
    constructor() {
        super(...arguments);
        this.loading = true;
        // :: abas
        this.tabs = [];
        this.tab = 'conta';
        /** Uma aba so nao e escolha - a barra some em vez de mostrar um botao inerte. */
        this.showTabs = false;
        // :: dados basicos - os campos sao os da aba ATIVA
        /** O titulo do cartao, que muda com o escopo: seus dados ou os da empresa. */
        this.profileTitle = 'Dados básicos';
        this.profileFields = [];
        this.profileBusy = false;
        /** Se algo foi mexido - e o `isDirty` de la, que liga o botao e troca a variante. */
        this.profileDirty = false;
        /**
         * Conta as escritas PROGRAMATICAS nos campos - ver o `revision` do editor de
         * faixas, que existe pelo mesmo motivo.
         *
         * Campo nao controlado ignora mudanca de `defaultValue`; amarrar o `key` ao
         * valor nao resolve, porque digitar nao redesenha e o React nunca ve o valor
         * digitado na chave.
         */
        this.formRevision = 0;
        /**
         * O radio "É PROFISSIONAL DA SAÚDE?".
         *
         * Nao aparece para admin nem para admin de empresa, como la.
         */
        this.showHealthProfessional = false;
        this.healthProfessional = false;
        /** As UFs do seletor de registro. */
        this.ufOptions = [];
        // :: senha
        this.currentPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
        this.passwordBusy = false;
        this.passwordDirty = false;
        // :: senha e limites aparecem so na aba em que fazem sentido
        /** Trocar a senha e da CONTA - nao existe senha de empresa nem do sistema. */
        this.showPassword = false;
        /**
         * A aparencia do painel, na aba da CONTA - a mesma escolha do menu do nome, para
         * quem a procurar aqui. Ver `RestrictedPresenter.themeOptions`.
         */
        this.themes = [];
        // :: parametros de status
        /** Se o leitor edita os padroes globais ou os proprios. */
        this.editingDefaults = false;
        /** Se o editor de faixas pertence a aba aberta. */
        this.showBands = false;
        this.onHealthProfessionalChanged = Scope.SYNC_ACTION_BOOLEAN;
        this.onSaveProfile = Scope.ASYNC_ACTION;
        this.onCurrentPasswordChanged = Scope.SYNC_ACTION_STRING;
        this.onNewPasswordChanged = Scope.SYNC_ACTION_STRING;
        this.onConfirmPasswordChanged = Scope.SYNC_ACTION_STRING;
        this.onSavePassword = Scope.ASYNC_ACTION;
        /** O "Cancelar" da senha: limpa os tres campos, como o `reset()` de la. */
        this.onCancelPassword = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], MyDataScope.prototype, "loading", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], MyDataScope.prototype, "error", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], MyDataScope.prototype, "tabs", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], MyDataScope.prototype, "tab", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MyDataScope.prototype, "showTabs", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MyDataScope.prototype, "profileTitle", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], MyDataScope.prototype, "profileFields", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MyDataScope.prototype, "profileBusy", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], MyDataScope.prototype, "profileError", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MyDataScope.prototype, "profileDirty", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MyDataScope.prototype, "formRevision", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MyDataScope.prototype, "showHealthProfessional", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MyDataScope.prototype, "healthProfessional", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], MyDataScope.prototype, "ufOptions", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MyDataScope.prototype, "currentPassword", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MyDataScope.prototype, "newPassword", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MyDataScope.prototype, "confirmPassword", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MyDataScope.prototype, "passwordBusy", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], MyDataScope.prototype, "passwordError", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MyDataScope.prototype, "passwordDirty", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MyDataScope.prototype, "showPassword", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], MyDataScope.prototype, "themes", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MyDataScope.prototype, "editingDefaults", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MyDataScope.prototype, "showBands", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], MyDataScope.prototype, "bands", void 0);
MyDataScope = __decorate([
    Observable
], MyDataScope);
export { MyDataScope };
//# sourceMappingURL=my-data.scope.js.map